import React, { useState } from 'react';
import './login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();

    // Login.js
    if (username === 'admin' && password === 'hr@123') {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('role', 'admin');
      if (onLogin) onLogin();

    } 
    else if (username === 'others' && password === 'Other@123') {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('role', 'user_1');
      if (onLogin) onLogin();
    } 
    // else if (username === 'fazo_shivani' && password === 'shivani@123') {
    //   localStorage.setItem('isAuthenticated', 'true');
    //   localStorage.setItem('role', 'user_2');
    //   if (onLogin) onLogin();
    // }
    else {
      setMsg('❌ Invalid username or password');
    }

  };

  return (
    <div className="login-box">
      <h2>Login</h2>
      <form onSubmit={handleLogin} autoComplete="off">
        {/* Hidden dummy fields to trick browser autofill */}
        <input type="text" name="fakeusernameremembered" style={{ display: 'none' }} />
        <input type="password" name="fakepasswordremembered" style={{ display: 'none' }} />

        <input
          type="text"
          placeholder="Username"
          name="username" // optional
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="new-username" // prevents browser from autofilling
          required
        /><br />

        <input
          type="password"
          placeholder="Password"
          name="password" // optional
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="new-password" // prevents browser from autofilling
          required
        /><br />

        <button type="submit">Login</button>
    


      </form>
      {msg && <p style={{ color: msg.includes('success') ? 'green' : 'red' }}>{msg}</p>}
    </div>
  );
};

export default Login;
